import dayjs from 'dayjs';
import Evaluation from './Evaluation';
import Organization from './Organization.js';
import UserType from '../enums/UserType.js';
import Department from './Department.js';
import Job from './Job.js';
import Achievement from './Achievement.js';
import SalaryReview from './SalaryReview.js';
import Bonus from './Bonus.js';
import EmploymentPattern from './EmploymentPattern';
import Qualification from './Qualification';
import UserTypeModel from './UserType';
import UsersEvaluator from './UsersEvaluator';

export default class User {
    constructor(data) {
      this.id = data?.id;
      this.userTypeId = data?.userTypeId;
      this.employmentPatternId = data?.employmentPatternId;
      this.departmentId = data?.departmentId;
      this.jobId = data?.jobId;
      this.name = data?.name;
      this.username = data?.username;
      this.email = data?.email;
      this.displayName = data?.displayName;
      this.type = data?.type ? UserType.of(data.type) : null;
      this.avatarPath = data?.avatarPath;
      this.memo = data?.memo;
      this.custom1 = data?.custom1;
      this.custom2 = data?.custom2;
      this.custom3 = data?.custom3;
      this.joinedOn = data?.joinedOn ? dayjs(data.joinedOn) : null;
      this.updatedAt = data?.updatedAt ? dayjs(data.updatedAt) : null;

      this.organization = data?.organization ? new Organization(data.organization) : [];
      this.employmentPattern = data?.employmentPattern ? new EmploymentPattern(data.employmentPattern) : [];
      this.department = data?.department ? new Department(data.department) : [];
      this.userType = data?.userType ? new UserTypeModel(data.userType) : [];

      this.jobs = data?.jobs ? data.jobs.map((j) => new Job(j)) : [];
      this.qualifications = data?.qualifications ? data.qualifications.map((q) => new Qualification(q)) : [];
      this.usersEvaluators = data?.usersEvaluators ? data.usersEvaluators.map((e) => new UsersEvaluator(e)) : [];

      this.finalEvaluations = data?.finalEvaluations ? data.finalEvaluations.map((e) => new Evaluation(e)) : [];
      this.achievements = data?.achievements ? data.achievements.map((a) => new Achievement(a)) : [];
      this.departments = data?.departments ? data.departments.map((d) => new Department(d)) : [];

      this.salaryReviews = data?.salaryReviews ? data.salaryReviews.map((s) => new SalaryReview(s)) : [];
      this.bonuses = data?.bonuses ? data.bonuses.map((b) => new Bonus(b)) : [];

      this.evaluatorIds = data?.usersEvaluators ? Object.fromEntries(data.usersEvaluators.map(e => [e.stage, e.evaluator.id])) : {};
      this.departmentIds = data?.departmentIds ?? (data?.departments ? data.departments.map(d => d.id) : []);
    }

  /**
   *
   * 評価データの連想配列を読み込む
   * key: type, value: evaluation
   *
   * @param {Object} data
   * @param {number} numStages
   */
  loadEvaluations(data, numStages) {
    if (!data) {
      this.selfEvaluation = new Evaluation(null);
      this.finalEvaluation = new Evaluation(null);
      this.otherEvaluations = {};
      for (let i = 1; i <= numStages; i++) {
        this.otherEvaluations[i] = new Evaluation(null);
      }
      return;
    }

    this.selfEvaluation = new Evaluation(data['SELF']);
    this.finalEvaluation = new Evaluation(data['FINAL']);

    this.otherEvaluations = {};
    for (let i = 1; i <= numStages; i++) {
      const key = `OTHER#${i}`;
      this.otherEvaluations[i] = new Evaluation(data[key]);
    }
  }

  /**
   * 特別評価点を読み込み、プロパティにセットする
   * @param {number|null} val
   */
  loadAdditionalPoint(val) {
    this.additionalPoint = val ? val : 0;
  }

  /**
   * 最終評価がスタートしているか
   *
   * @returns {boolean}
   */
  get isFinalEvaluationStarted() {
    // PENDINGであれば一時的に自己評価や他者評価の編集を許可するので最終評価がスタートしているとみなさない
    if (this.finalEvaluation.status === 'PENDING') {
      return false;
    }
    return this.finalEvaluation.status !== undefined;
  }
}
